import React from 'react';
import classNames from 'classnames/bind';

import PropTypes from 'prop-types';
import styles from './styles.pcss';
const cx = classNames.bind(styles);

export const ServiceCardWrapper = ({ children, isMobile }) => (
  <div className={cx('component', { isMobile })}>{children}</div>
);

ServiceCardWrapper.propTypes = {
  isMobile: PropTypes.bool,
};
